export const CLS_VERSION = 21

export default defineNuxtPlugin({
  parallel: false,
  async setup() {
    const mobile = useMobile()
    const start = computed(() => `cls-${CLS_VERSION}-${mobile.value ? 'm' : 'd'}-`)
    return { provide: { clsClass: (name: string) => `${start.value}${name}` } }
  },
})
